// import React from 'react'
// import { UpcomingData } from '../../Data/UpcomingEventsData';
// import { Grid, ImageList, ImageListItem, Paper } from '@mui/material';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import Blink from 'react-blink-text';
// import imgH from '../../assets/images/Web1920.jpg'
// import EventIcon from '@mui/icons-material/Event';
// import './ViewMore.css'
// import Breadcrumb from '../../Components/Breadcrumb';
// import { UpcomingIcon } from '../../Components/SvgIcons';

// const data = UpcomingData;

// const UpcomingEventPage = () => {
//   window.scrollTo(0, 270);
//   return (
//     <>
//     <div className="bredDivMob">
//       <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
//       </div>
//       <div className="bredDivDesk">
//       <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
//       </div>
//       <div className='bg-light py-3'>
//       <Paper elevation={0} className='my-5 mx-5 bg-light'>
//       {data.map((items, index) => (
//         <div className="upcoming-texts" key={index}>
//         <div className="home-card-content">
//           <Grid container>
//              <Grid xs={1.5} md={0.5}>
//              <div className='upcomingDate' >
//                <EventIcon /> {items.date}
//              </div>
//              </Grid>
//              <Grid xs={10.5} md={11.5}>
//              <h5 className="home-card-title g-0 fs-5"> {items.title}</h5>
//           <div className="home-card-body fs-6 mt-3 mx-lg-3" >{items.description}</div> {/* Render news body */}
//           <div className="home-card-body fs-6 mt-3 mx-lg-3" >{items.description2}</div> {/* Render news body */}

//           <div>
//           <div  className='fs-5 g-0'>
//            { 
//            items.Doc.pdf.length !== 0 &&
//            <a href={items.Doc.pdf} target='_blank' className='fs-6 g-3 mt-2 mx-lg-3'> <PictureAsPdfIcon className='pdficon'/>   view more...</a>}
//           </div>
//            <ImageList sx={{ width: 500}}cols={2} gap={10} className='mt-3 mb-2 mx-lg-4'>

//                    {items.Doc.image.map((image, imageIndex) => (
//                   <ImageListItem  key={imageIndex} >
//                   <img className='rounded'
//                   src={image}
//                   alt={`Image ${imageIndex + 1}`}
//                   />
//                   </ImageListItem>
//                  ))}
//           </ImageList>
//           </div>
          
//           <div className="Application home-card-Footer mt-3 mx-1">
//             <Blink color="gray" text={items.updatedDate} fontSize={15}></Blink>
//           </div>
//              </Grid>

//           </Grid>
         
//         </div>
//       </div>
//       ))}
//     </Paper>
//     </div>
//     </>
//   )
// }

// export default UpcomingEventPage;


// import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { UpcomingData } from '../../Data/UpcomingEventsData';
// import { Grid, Paper, ImageList, ImageListItem, Box } from '@mui/material';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import EventIcon from '@mui/icons-material/Event';
// import Blink from 'react-blink-text';
// import Breadcrumb from '../../Components/Breadcrumb';

// const UpcomingEventPage = () => {
//   const { id } = useParams();

//   useEffect(() => {
//     window.scrollTo(0, 270);
//   }, []);

//   const displayedData = id
//     ? UpcomingData.filter((item) => item.id === parseInt(id))
//     : UpcomingData;

//   return (
//     <>
//       <div className="bredDivMob">
//         <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
//       </div>
//       <div className="bredDivDesk">
//         <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
//       </div>

//       <div className='bg-light py-3'>
//         <Paper elevation={0} className='my-5 mx-5 bg-light'>
//           {displayedData.map((items) => (
//             <div className="upcoming-texts" key={items.id}>
//               <div className="home-card-content">

//                 {/* IMAGE BANNER - show thumbnail if exists, else colored header */}
//                 {items.thumbnail ? (
//                   <Box sx={{ mb: 3, borderRadius: 3, overflow: 'hidden', maxHeight: 350 }}>
//                     <img
//                       src={items.thumbnail}
//                       alt={items.title}
//                       style={{ width: '100%', maxHeight: 350, objectFit: 'cover', borderRadius: 12 }}
//                     />
//                   </Box>
//                 ) : (
//                   <Box sx={{
//                     mb: 3, borderRadius: 3, height: 160,
//                     background: 'linear-gradient(135deg, #2e7d32, #66bb6a)',
//                     display: 'flex', alignItems: 'center', justifyContent: 'center'
//                   }}>
//                     <EventIcon sx={{ color: 'white', fontSize: 72, opacity: 0.7 }} />
//                   </Box>
//                 )}

//                 <Grid container>
//                   <Grid xs={1.5} md={0.5}>
//                     <div className='upcomingDate'>
//                       <EventIcon /> {items.date}
//                     </div>
//                   </Grid>
//                   <Grid xs={10.5} md={11.5}>
//                     <h5 className="home-card-title g-0 fs-5">{items.title}</h5>

//                     {/* Description */}
//                     {items.description && (
//                       <div className="home-card-body fs-6 mt-3 mx-lg-3">{items.description}</div>
//                     )}
//                     {items.description2 && (
//                       <div className="home-card-body fs-6 mt-2 mx-lg-3">{items.description2}</div>
//                     )}

//                     {/* PDF */}
//                     {items.Doc?.pdf?.length > 0 && (
//                       <div className='fs-5 mt-2'>
//                         <a href={items.Doc.pdf[0]} target='_blank' rel="noreferrer" className='fs-6 mx-lg-3'>
//                           <PictureAsPdfIcon className='pdficon' /> View PDF
//                         </a>
//                       </div>
//                     )}

//                     {/* Images grid */}
//                     {items.Doc?.image?.length > 0 && (
//                       <ImageList sx={{ width: 500 }} cols={2} gap={10} className='mt-3 mb-2 mx-lg-4'>
//                         {items.Doc.image.map((image, imageIndex) => (
//                           <ImageListItem key={imageIndex}>
//                             <img className='rounded' src={image} alt={`Image ${imageIndex + 1}`} />
//                           </ImageListItem>
//                         ))}
//                       </ImageList>
//                     )}

//                     <div className="Application home-card-Footer mt-3 mx-1">
//                       <Blink color="gray" text={items.updatedDate} fontSize={15} />
//                     </div>
//                   </Grid>
//                 </Grid>

//               </div>
//             </div>
//           ))}
//         </Paper>
//       </div>
//     </>
//   );
// };

// export default UpcomingEventPage;

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { UpcomingData } from '../../Data/UpcomingEventsData';
import { Grid, Paper, ImageList, ImageListItem, Box } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EventIcon from '@mui/icons-material/Event';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Blink from 'react-blink-text';
import Breadcrumb from '../../Components/Breadcrumb';

const isYouTubeLink = (url) =>
  url && (url.includes("youtube.com") || url.includes("youtu.be"));

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
  const longMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  if (longMatch) return `https://www.youtube.com/embed/${longMatch[1]}`;
  return null;
};

const UpcomingEventPage = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 270);
  }, []);

  const displayedData = id
    ? UpcomingData.filter((item) => item.id === parseInt(id))
    : UpcomingData;

  return (
    <>
      <div className="bredDivMob">
        <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
      </div>
      <div className="bredDivDesk">
        <Breadcrumb pageTitle={<h3 className='fs-3 mt-0 text-bold decorated text-light'>Upcoming Event</h3>} />
      </div>

      <div className='bg-light py-3'>
        <Paper elevation={0} className='my-5 mx-5 bg-light'>
          {displayedData.map((items) => {
            const hasImage = items.Doc?.image?.length > 0;
            const hasThumbnail = !!items.thumbnail;
            const hasLocalVideo = !!items.Doc?.video;
            const hasYouTube = isYouTubeLink(items.link);
            const embedUrl = hasYouTube ? getYouTubeEmbedUrl(items.link) : null;

            return (
              <div className="upcoming-texts" key={items.id}>
                <div className="home-card-content">

                  {/* 1. Local video */}
                  {hasLocalVideo && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: 'hidden' }}>
                      <video controls style={{ width: '100%', maxHeight: 400, borderRadius: 12, background: '#000' }}>
                        <source src={items.Doc.video} type="video/mp4" />
                      </video>
                    </Box>
                  )}

                  {/* 2. YouTube embed */}
                  {!hasLocalVideo && hasYouTube && embedUrl && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: 'hidden' }}>
                      <iframe
                        width="100%" height="380" src={embedUrl} title={items.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen style={{ borderRadius: 12, display: 'block' }}
                      />
                    </Box>
                  )}

                  {/* 3. Thumbnail — only if no video AND no link */}
                  {!hasLocalVideo && !items.link && hasThumbnail && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: 'hidden', maxHeight: 350 }}>
                      <img
                        src={items.thumbnail} alt={items.title}
                        style={{ width: '100%', maxHeight: 350, objectFit: 'cover', borderRadius: 12 }}
                      />
                    </Box>
                  )}

                  {/* 4. Doc image — only if no video AND no link AND no thumbnail */}
                  {!hasLocalVideo && !items.link && !hasThumbnail && hasImage && (
                    <Box sx={{ mb: 3, borderRadius: 3, overflow: 'hidden', maxHeight: 350 }}>
                      <img
                        src={items.Doc.image[0]} alt={items.title}
                        style={{ width: '100%', maxHeight: 350, objectFit: 'cover', borderRadius: 12 }}
                      />
                    </Box>
                  )}

                  {/* 5. Fallback placeholder */}
                  {!hasLocalVideo && !items.link && !hasThumbnail && !hasImage && (
                    <Box sx={{
                      mb: 3, borderRadius: 3, height: 160,
                      background: 'linear-gradient(135deg, #2e7d32, #66bb6a)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                      <EventIcon sx={{ color: 'white', fontSize: 72, opacity: 0.7 }} />
                    </Box>
                  )}

                  <Grid container>
                    <Grid xs={1.5} md={0.5}>
                      <div className='upcomingDate'>
                        <EventIcon /> {items.date}
                      </div>
                    </Grid>
                    <Grid xs={10.5} md={11.5}>
                      <h5 className="home-card-title g-0 fs-5">{items.title}</h5>

                      {items.description && (
                        <div className="home-card-body fs-6 mt-3 mx-lg-3">{items.description}</div>
                      )}
                      {items.description2 && (
                        <div className="home-card-body fs-6 mt-2 mx-lg-3">{items.description2}</div>
                      )}

                      {items.Doc?.pdf?.length > 0 && (
                        <div className='fs-5 mt-2'>
                          <a href={items.Doc.pdf[0]} target='_blank' rel="noreferrer" className='fs-6 mx-lg-3'>
                            <PictureAsPdfIcon className='pdficon' /> View PDF
                          </a>
                        </div>
                      )}

                      {hasImage && (
                        <ImageList sx={{ width: 500 }} cols={2} gap={10} className='mt-3 mb-2 mx-lg-4'>
                          {items.Doc.image.map((image, imageIndex) => (
                            <ImageListItem key={imageIndex}>
                              <img className='rounded' src={image} alt={`Image ${imageIndex + 1}`} />
                            </ImageListItem>
                          ))}
                        </ImageList>
                      )}

                      {hasYouTube && (
                        <div className="mt-2 mx-lg-3">
                          <a href={items.link} target="_blank" rel="noreferrer" style={{ color: 'steelblue', fontSize: 14 }}>
                            <PlayCircleIcon fontSize="small" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                            Open on YouTube
                          </a>
                        </div>
                      )}

                      {items.link && !hasYouTube && (
                        <div className="mt-2 mx-lg-3">
                          <a href={items.link} target="_blank" rel="noreferrer" style={{ color: 'steelblue', fontSize: 14 }}>
                            🔗 View Link
                          </a>
                        </div>
                      )}

                      <div className="Application home-card-Footer mt-3 mx-1">
                        <Blink color="gray" text={items.updatedDate} fontSize={15} />
                      </div>
                    </Grid>
                  </Grid>

                </div>
              </div>
            );
          })}
        </Paper>
      </div>
    </>
  );
};

export default UpcomingEventPage;